import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

export default class TrustHandbookAPI {
  static getTrustHandbook (languageCode, username) {
    let url = `${apiUrl}/content/account/trust_handbook/${username}/${languageCode}`;
    const request = new Request(url, {
      method: 'GET',
      headers: getHeaders(),
    });
    return fetchRequest(request);
  }
}
